<template>
  <CContainer class="px-0" v-if="$policy('store').create_own">
    <CRow class="scroll-bar">
        <PublishersCard/>
        <ConversionsCard class=""/>
        <ClicksCard/>
    </CRow>
    <CRow>
      <ReportsBarChartForStore />
      <BestPublishersTable />
      <LatestConversionsTable />
    </CRow>
  </CContainer>
  <CContainer class="px-0" v-else-if="$policy('store').join">
    <CRow class="scroll-bar">
        <IncomeCard />
        <ConversionsCard class=""/>
        <ClicksCard/>
    </CRow>
    <SelectedStores class="pr-sm-0" />
    <CRow>
      <ReportsBarChartForPublisher />
      <LatestConversionsTable />
    </CRow>
  </CContainer>
  <CContainer class="px-0" v-else>
    <CRow class="scroll-bar">
      <PublishersCard/>
      <ConversionsCard class=""/>
      <ClicksCard/>
    </CRow>
    <SelectedStores class="pr-sm-0" />
    <CRow>
      <ReportsBarChartForOwner />
      <LatestConversionsTable />
      <BestPublishersTable />
    </CRow>
  </CContainer>
</template>

<script>
import * as Widgets from './partials'

export default {
  name: "Dashboard",

  components: {
    ...Widgets
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  @media only screen and (min-width: 992px) {
    .scroll-bar {
      justify-content: center;
    }
  }
  @media only screen and (max-width: 991px) {
    .scroll-bar {
      display: flex;
      flex-wrap: wrap;
      // margin-left: -20px;
      // margin-right: -20px;
      flex-wrap: nowrap;
      overflow-x: scroll;

      div:nth-child(1) {
       min-width: 200px;
      }
      div:nth-child(2) {
       min-width: 250px;
      }
    }
    .scroll-bar::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>


<style lang="scss" scoped>
::v-deep {
  @keyframes placeHolderShimmer {
    0% {
      background-position: -20px 0
    }
    25% {
      background-position: 420px 0
    }
    50% {
      background-position: -20px 0
    }
    75% {
      background-position: 420px 0
    }
    100% {
      background-position: -20px 0
    }
  }

  .animated-background {
    animation-duration: 9s;
    animation-name: placeHolderShimmer;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    background-color: #fff;
    background: linear-gradient(to right, #ddd 98%, #eee 1%, #eee 1%);
    background-size: 800px auto;
    position: relative;
  }

  .animated-background.s-4 {
    animation-duration: 6s!important;
  }

  .background-masker {
    background-color: #fff;
    position: absolute;
  }

  .btn-divide-left {
    top: 0;
    left: 75%;
    height: 100%;
    width: 7%;
  }

  .static-background {
    background-color: #f6f7f8;
    background-size: 800px auto;
    position: relative;
  }
}
</style>